import { render } from "./SitesUpgradeModal.vue?vue&type=template&id=ab53348c"
import script from "./SitesUpgradeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SitesUpgradeModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SitesUpgradeModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab53348c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab53348c', __exports__)) {
    api.reload('ab53348c', __exports__)
  }
  
  module.hot.accept("./SitesUpgradeModal.vue?vue&type=template&id=ab53348c", () => {
    api.rerender('ab53348c', render)
  })

}


export default __exports__